import React, { useEffect, useState } from 'react';
import { Trash2, Check, Loader2, Mail, Phone, Calendar, ChevronDown, ChevronUp, Download } from 'lucide-react';
import { adminGetInscriptions, adminMarkInsRead, adminDeleteIns } from '../../lib/api';

export default function AdminInscripciones() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(null);

  const load = () => { setLoading(true); adminGetInscriptions().then(setItems).finally(() => setLoading(false)); };
  useEffect(load, []);

  const markRead = async (id) => { await adminMarkInsRead(id); load(); };
  const remove = async (id) => { if (confirm('¿Borrar?')) { await adminDeleteIns(id); load(); } };

  const exportCSV = () => {
    const rows = [['Fecha', 'Experiencia', 'Nombre', 'Email', 'Teléfono', 'Hándicap', 'Notas']];
    items.forEach((i) => rows.push([i.created_at, i.experience_title || i.experience_id, i.nombre, i.email, i.telefono, i.handicap, i.notas]));
    const csv = rows.map((r) => r.map((c) => `"${(c || '').toString().replace(/"/g, '""')}"`).join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = `inscripciones-${Date.now()}.csv`; a.click();
  };

  return (
    <div className="p-6 md:p-10">
      <div className="flex items-center justify-between mb-8">
        <div><h1 className="font-serif-display text-3xl text-white mb-1">Inscripciones</h1><p className="text-white/55">{items.length} en total</p></div>
        <button onClick={exportCSV} className="gd-btn-ghost px-4 py-2 text-[11px] uppercase tracking-widest inline-flex items-center gap-2"><Download size={13} /> Exportar CSV</button>
      </div>
      {loading ? <Loader2 className="animate-spin text-[#c9a063]" /> : (
        <div className="space-y-2">
          {items.length === 0 && <div className="text-white/40 py-12 text-center">No hay inscripciones todavía</div>}
          {items.map((i) => (
            <div key={i.id} className={`gd-card ${!i.read ? 'border-l-4 border-l-[#c9a063]' : ''}`}>
              <button onClick={() => setExpanded(expanded === i.id ? null : i.id)} className="w-full flex items-center gap-4 px-5 py-4 text-left">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 text-[10px] uppercase tracking-widest text-white/50">
                    <span className="flex items-center gap-1"><Calendar size={11} /> {new Date(i.created_at).toLocaleDateString('es-ES')}</span>
                    <span>•</span>
                    <span className="text-[#c9a063] truncate">{i.experience_title || i.experience_id}</span>
                    {!i.read && <span className="px-2 py-0.5 bg-[#c9a063]/15 text-[#c9a063] border border-[#c9a063]/30">Nueva</span>}
                  </div>
                  <div className="font-serif-display text-lg text-white mt-1">{i.nombre}</div>
                </div>
                <span className="text-white/40">{expanded === i.id ? <ChevronUp size={16} /> : <ChevronDown size={16} />}</span>
              </button>
              {expanded === i.id && (
                <div className="px-5 pb-5 border-t border-white/5 pt-4 space-y-3 text-sm">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-white/70">
                    <div><Mail size={12} className="inline text-[#c9a063] mr-2" /><a href={`mailto:${i.email}`} className="hover:text-[#c9a063]">{i.email}</a></div>
                    <div><Phone size={12} className="inline text-[#c9a063] mr-2" />{i.telefono || '—'}</div>
                    <div>Hándicap: <span className="text-white">{i.handicap || '—'}</span></div>
                  </div>
                  {i.notas && <div className="text-white/70 bg-white/5 p-3 italic">{i.notas}</div>}
                  <div className="flex gap-2">
                    {!i.read && <button onClick={() => markRead(i.id)} className="text-xs px-3 py-1.5 border border-emerald-500/40 text-emerald-400 hover:bg-emerald-500/10 inline-flex items-center gap-1"><Check size={11} /> Marcar leída</button>}
                    <button onClick={() => remove(i.id)} className="text-xs px-3 py-1.5 border border-red-500/40 text-red-400 hover:bg-red-500/10 inline-flex items-center gap-1"><Trash2 size={11} /></button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
